// material-ui
import {} from '@mui/material'
import * as localStorageService from 'components/localStorageService'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import SelectProfileComponent from 'components/SelectProfileComponent'
import { getUserClaims } from 'features/application/application-slice'
import { get_all_profile } from 'features/profile/profile-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let profile_list = useSelector(get_all_profile)

  useEffect(() => {
    if (claims?.fire_user) {
      dispatch(autoThunks.get_profiles({ userId: claims?.fire_user }))
    }
  }, [claims?.fire_user])
  useEffect(() => {
    function storeProfilesInCache(): any {
      if (claims?.user) {
        localStorageService.store(
          { data: profile_list },
          `profiles-${claims?.user}`,
        )
      }
    }
    storeProfilesInCache()
  }, [claims?.user, JSON.stringify(profile_list || {})])

  function main(comp: any): any {
    return (() => {
      return (
        <div className="profile component">
          <SelectProfileComponent />
        </div>
      )
    })()
  }

  let output_main = main(null)

  return output_main
}
